import { type ComponentsOverrides } from '@mui/material/styles'

import { RADIUS_1 } from '@Styles/constants/radius'

export const overridesTextField = (): ComponentsOverrides['MuiTextField'] => ({
  root: {
    borderRadius: RADIUS_1,
  },
})
